export const scrollEvents = ['scroll', 'mousedown', 'DOMMouseScroll', 'mousewheel', 'wheel', 'touchmove', 'keyup']
